
export const common = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.treatments': 'العلاجات',
  'nav.howItWorks': 'كيف يعمل',
  'nav.supervision': 'الإشراف',
  'nav.about': 'من نحن',
  'nav.bookNow': 'احجز الآن',
  'nav.language': 'اللغة',

  // Hero
  'hero.badge': 'أطباء حقيقيون. رعاية حقيقية. راحة بال حقيقية.',
  'hero.title.line1': 'أنت تستحق ابتسامة',
  'hero.title.line2': 'تفتخر بها',
  'hero.subtitle1': 'سواء كان ألماً تتجاهله، أو ابتسامة تخفيها، أو تكاليف جعلتك تنتظر — لم يعد عليك الانتظار بعد الآن.',
  'hero.subtitle2': 'نجعل رعاية الأسنان العالمية في تركيا آمنة ومدعومة وفي متناول يدك تماماً — مع طبيب يراقب كل خطوة.',
  'hero.cta.primary': 'ابدأ رحلتي',
  'hero.cta.secondary': 'تحدث مع شخص أولاً',
  'hero.feature1': 'إشراف طبي من البداية إلى النهاية',
  'hero.feature2': 'رعاية تناسب حياتك وميزانيتك',
  'hero.feature3': 'مدعوم في كل خطوة، قريباً أو بعيداً',

  // Services
  'services.badge': 'رحلتك تبدأ هنا',
  'services.title': 'علاجات تغير شعورك كل يوم',
  'services.subtitle': 'سواء كنت مستعداً للابتسام دون تردد، أو الأكل دون قلق، أو ببساطة الشعور بأنك نفسك مرة أخرى — نحن هنا لمساعدتك',
  'services.cta': 'استكشف جميع العلاجات',
  'services.swipeHint': 'اسحب لاستكشاف المزيد من العلاجات',
  'services.learnMore': 'اعرف المزيد',
  'services.startingFrom': 'ابتداءً من',
  'services.perTooth': 'لكل سن',

  // Service: Dental Implants
  'service.implants.title': 'زراعة الأسنان',
  'service.implants.desc': 'كل وتحدث وتكلم بثقة كاملة مرة أخرى. اشعر بأنك نفسك مع أسنان تبدو وتشعر وتعمل تماماً مثل أسنانك الطبيعية.',
  // Service: Veneers
  'service.veneers.title': 'قشور البورسلين',
  'service.veneers.desc': 'توقف عن إخفاء ابتسامتك في الصور. استيقظ كل يوم وأنت تحب ما تراه في المرآة مع ابتسامة تشعر أخيراً أنها أنت.',

  // Service: Smile Makeover
  'service.smile.title': 'تجميل الابتسامة',
  'service.smile.desc': 'غيّر شعورك تجاه نفسك. تجميل ابتسامة كامل مصمم حول وجهك وحياتك والثقة التي تستحقها.',

  // Service: Orthodontics
  'service.orthodontics.title': 'تقويم الأسنان',
  'service.orthodontics.desc': 'قوّم أسنانك دون الشعور بالحرج. علاج سري يناسب نمط حياتك ويمنحك الابتسامة التي طالما أردتها.',

  // Service: Whitening
  'service.whitening.title': 'تبييض الأسنان',
  'service.whitening.desc': 'اشعر بالثقة في كل محادثة. ابتسامة أكثر إشراقاً وبياضاً تجعلك تشعر بالرضا عن نفسك في كل مرة تتحدث فيها.',

  // Service: Root Canal
  'service.root.title': 'علاج قناة الجذر',
  'service.root.desc': 'توقف عن العيش مع ألم الأسنان. احفظ سنك الطبيعي وعد للاستمتاع بالحياة دون إزعاج أو قلق مستمر.',

  // Service: Crowns
  'service.crowns.title': 'تيجان الأسنان',
  'service.crowns.desc': 'احمِ واستعد الأسنان التالفة حتى تتمكن من تناول ما تحب مرة أخرى. تيجان قوية وطبيعية المظهر تدوم لسنوات.',

  // Service: All-on-4
  'service.allon4.title': 'زراعة الكل على 4',
  'service.allon4.desc': 'استعد حياتك في يوم واحد فقط. مجموعة كاملة من الأسنان الدائمة تتيح لك الأكل والابتسام والعيش دون حدود أو إحراج.',

  // How It Works
  'how.badge': 'عملية بسيطة',
  'how.title': 'كيف يعمل',
  'how.subtitle': 'أربع خطوات بسيطة للحصول على رعاية أسنان عالمية مع شفافية كاملة',
  'how.cta': 'ابدأ رحلتك',

  'how.step1.number': '01',
  'how.step1.title': 'احجز علاجك',
  'how.step1.desc': 'اختر علاج الأسنان الخاص بك وقم بتحميل الأشعة السينية أو الفحوصات. سيقوم فريقنا بالمراجعة وإنشاء خطة علاج شخصية.',

  'how.step2.number': '02',
  'how.step2.title': 'اختر الإشراف',
  'how.step2.desc': 'اختر خيار الإشراف المفضل لديك: طبيب مستقل من طرف ثالث، أو طبيب أسنانك في بلدك (يحصل على 10%)، أو خبيرنا الداخلي.',

  'how.step3.number': '03',
  'how.step3.title': 'احصل على العلاج بشفافية',
  'how.step3.desc': 'احصل على علاجك في عيادتنا المعتمدة من JCI. يراجع المشرف المختار جميع الأشعة السينية والفحوصات وتقدم العلاج في الوقت الفعلي.',

  'how.step4.number': '04',
  'how.step4.title': 'رعاية المتابعة',
  'how.step4.desc': 'استمر في الرعاية مع طبيب أسنانك في بلدك الذي لديه معرفة كاملة بعلاجك. نوفر جميع السجلات والدعم المستمر.',

  // Supervision
  'supervision.badge': 'أنت محمي في كل خطوة',
  'supervision.title': 'قلق بشأن الذهاب للخارج لرعاية الأسنان؟',
  'supervision.subtitle': 'هذا القلق صحيح تماماً — وهذا بالضبط سبب بنائنا لهذا. كل مريض يحصل على مشرف مخصص يراقب علاجه من اليوم الأول حتى الانتهاء.',
  'supervision.swipeHint': 'اسحب لاستكشاف الخيارات',
  'supervision.chooseOption': 'اختر هذا الخيار عند الحجز',

  'supervision.option1.title': 'طبيب مستقل من طرف ثالث',
  'supervision.option1.badge': 'الأكثر موثوقية',
  'supervision.option1.desc': 'شخص في ركنك يجيب فقط لك — وليس للعيادة. يراجعون كل فحص، يوافقون على كل خطوة، ويتأكدون من عدم تفويت أي شيء.',
  'supervision.option1.feature1': 'يراجع الأشعة السينية قبل أي شيء يبدأ',
  'supervision.option1.feature2': 'يوافق على خطة العلاج بشكل مستقل',
  'supervision.option1.feature3': 'يتحقق في كل مرحلة من رعايتك',
  'supervision.option1.feature4': 'يؤكد أن النتيجة النهائية تلبي المعيار',
  'supervision.option1.feature5': 'صفر تضارب في المصالح — يعملون من أجلك',
  'supervision.option1.pricing': 'ما تحصل عليه: إشراف مستقل كامل',

  'supervision.option2.title': 'طبيبك الخاص في بلدك',
  'supervision.option2.badge': 'الأكثر راحة',
  'supervision.option2.desc': 'طبيب الأسنان الذي تثق به بالفعل يبقى جزءاً من رحلتك. يعرفون تاريخك، يعرفونك — ويبقون على اطلاع في كل خطوة.',
  'supervision.option2.feature1': 'يتلقى طبيب أسنانك جميع السجلات والفحوصات',
  'supervision.option2.feature2': 'يبقى على اطلاع في كل مرحلة علاج',
  'supervision.option2.feature3': 'يتعامل مع رعاية المتابعة في بلدك',
  'supervision.option2.feature4': 'يكسب 10% من تكلفة العلاج مقابل وقته',
  'supervision.option2.feature5': 'استمرارية سلسة — لا بداية من جديد',
  'supervision.option2.pricing': 'ما تحصل عليه: رعاية مألوفة، بدون فجوات',

  'supervision.option3.title': 'خبيرنا الداخلي',
  'supervision.option3.badge': 'مشمول',
  'supervision.option3.desc': 'متخصص كبير بخبرة 15+ سنة يراقب علاجك في الموقع. أنت لست مجرد مريض — أنت أولوية.',
  'supervision.option3.feature1': '15+ سنة من الخبرة المتخصصة',
  'supervision.option3.feature2': 'موجود في العيادة طوال رعايتك',
  'supervision.option3.feature3': 'يستجيب فوراً إذا شعرت بأي شيء غير طبيعي',
  'supervision.option3.feature4': 'يحافظ على كل خطوة بأعلى معيار',
  'supervision.option3.feature5': 'مشمول بالفعل — لا تكلفة إضافية عليك',
  'supervision.option3.pricing': 'ما تحصل عليه: عيون خبيرة، دائماً موجودة',

  'supervision.why.title': 'لا يجب أن تأمل فقط في الأفضل',
  'supervision.why.desc': 'الذهاب للخارج لعلاج الأسنان يتطلب شجاعة. أنت تثق بأشخاص لم تقابلهم من قبل، في بلد قد لا تعرفه، بشيء شخصي مثل ابتسامتك. بنينا نظام الإشراف لدينا لأننا نؤمن أنك تستحق أكثر من وعد — تستحق شخصاً حقيقياً يراقب كل قرار يُتخذ بشأن رعايتك. ليس قائمة تحقق. ليس كتيباً. إنسان مسؤول أمامك.',

  // CTA
  'cta.title.line1': 'ابتسامتك كانت',
  'cta.title.line2': 'تنتظر طويلاً بما فيه الكفاية',
  'cta.subtitle1': 'نعلم أنه ليس من السهل اتخاذ هذه الخطوة. عدم اليقين، الأسئلة، "ماذا لو" — نسمعها كل يوم. هذا بالضبط سبب وجودنا هنا.',
  'cta.subtitle2': 'محادثتك الأولى مجانية، بدون ضغط، وبشروطك تماماً. فقط تحدث معنا — سنتولى الأمر من هناك.',
  'cta.button.primary': 'أنا مستعد للتحدث',
  'cta.button.secondary': 'الدردشة على واتساب',
  'cta.badge1': 'أطباء حقيقيون. رعاية حقيقية.',
  'cta.badge2': 'لا ضغط. لا عجلة.',
  'cta.badge3': 'أنت مدعوم في كل خطوة.',
  'cta.badge4': 'نتائج حقيقية. أشخاص حقيقيون.',

  // Footer
  'footer.brand.desc': 'نؤمن أن الجميع يستحقون الشعور بالثقة في ابتسامتهم. نحن هنا لجعل ذلك ممكناً — بأمان وصدق ومع طبيب حقيقي بجانبك.',
  'footer.cta': 'احجز استشارة',
  'footer.treatments': 'العلاجات',
  'footer.company': 'الشركة',
  'footer.resources': 'الموارد',
  'footer.phone': 'الهاتف',
  'footer.email': 'البريد الإلكتروني',
  'footer.location': 'الموقع',
  'footer.locationValue': 'إسطنبول، تركيا',
  'footer.copyright': '© {{year}} Plexus Alliance. جميع الحقوق محفوظة.',
  'footer.poweredBy': 'مدعوم من Readdy',

  // About page
  'about.hero.badge': 'قصتنا',
  'about.hero.title': 'بنينا شبكة الأمان التي كانت سياحة الأسنان تفتقر إليها',
  'about.hero.subtitle': 'تأسست Plexus Alliance على اعتقاد بسيط: يستحق المرضى صوتاً مستقلاً في علاجهم — خاصة عندما يكونون بعيدين عن وطنهم.',
  'about.mission.badge': 'مهمتنا',
  'about.mission.title': 'رعاية أسنان شفافة وخاضعة للإشراف لكل مريض في كل مكان.',
  'about.mission.desc': 'نربط المرضى بأفضل عيادات الأسنان في إسطنبول مع توفير طبقة الإشراف المستقل التي لا تقدمها معظم شركات سياحة الأسنان.',
  'about.values.badge': 'ما نؤمن به',
  'about.values.title': 'قيمنا الأساسية',
  'about.value1.title': 'الاستقلالية',
  'about.value1.desc': 'مشرفونا يجيبون لك فقط — وليس للعيادة.',
  'about.value2.title': 'الشفافية',
  'about.value2.desc': 'كل سجل، كل فحص، كل قرار — مرئي بالكامل لك.',
  'about.value3.title': 'الاستمرارية',
  'about.value3.desc': 'رعايتك لا تتوقف عندما تصعد على متن طائرتك للعودة.',
  'about.value4.title': 'إمكانية الوصول',
  'about.value4.desc': 'رعاية الأسنان العالمية لا ينبغي أن تكون امتيازاً. نجعلها في متناول الجميع.',

  // Treatments page
  'treatments.hero.badge': 'جميع العلاجات',
  'treatments.hero.title': 'ابحث عن علاجك',
  'treatments.hero.subtitle': 'من الزراعة الفردية إلى تجميل الابتسامة الكامل — كل علاج خاضع للإشراف وشفاف وبسعر عادل.',
  'treatments.filter.all': 'جميع العلاجات',
  'treatments.filter.implants': 'الزراعة',
  'treatments.filter.cosmetic': 'التجميل',
  'treatments.filter.orthodontics': 'التقويم',
  'treatments.filter.restorative': 'الترميم',
  'treatments.cta.title': 'لست متأكداً من العلاج الذي تحتاجه؟',
  'treatments.cta.desc': 'أخبرنا بما يزعجك — سنراجع حالتك مجاناً ونوصي بالمسار الصحيح.',
  'treatments.cta.button': 'احصل على تقييم مجاني',

  // Book Treatment page
  'book.hero.badge': 'ابدأ رحلتك',
  'book.hero.title': 'احجز علاجك',
  'book.hero.subtitle': 'أدخل التفاصيل أدناه وسنتواصل معك في غضون ساعات قليلة بخطة مخصصة.',
  'book.form.name': 'الاسم الكامل',
  'book.form.email': 'عنوان البريد الإلكتروني',
  'book.form.phone': 'الهاتف / واتساب',
  'book.form.treatment': 'العلاج المطلوب',
  'book.form.supervision': 'تفضيل الإشراف',
  'book.form.message': 'أخبرنا المزيد (اختياري)',
  'book.form.submit': 'إرسال طلبي',
  'book.form.submitting': 'جارٍ الإرسال...',
  'book.form.success': 'تم إرسال الطلب! سنتواصل معك في غضون ساعات قليلة.',

  // Partner Registration page
  'partner.hero.badge': 'شراكة معنا',
  'partner.hero.title': 'انضم إلى شبكة Plexus Alliance',
  'partner.hero.subtitle': 'هل أنت طبيب أسنان أو عيادة أو متخصص في الرعاية الصحية؟ شاركنا واكسب بينما تساعد مرضاك على الوصول إلى رعاية عالمية.',
  'partner.form.submit': 'إرسال الطلب',

  // How It Works page
  'hiw.hero.badge': 'العملية',
  'hiw.hero.title': 'كيف يعمل',
  'hiw.hero.subtitle': 'من رسالتك الأولى إلى فحصك الأخير — إليك بالضبط ما يحدث، خطوة بخطوة.',
  'hiw.faq.title': 'لا تزال لديك أسئلة؟',
  'hiw.cta.title': 'هل أنت مستعد لاتخاذ الخطوة الأولى؟',
  'hiw.cta.subtitle': 'يبدأ بمجرد رسالة واحدة. أخبرنا بما تحتاجه — سنتولى كل شيء من هناك.',
  'hiw.cta.button': 'ابدأ رحلتي',

  // Supervision page
  'sup.hero.badge': 'حمايتك',
  'sup.hero.title': 'الإشراف الطبي',
  'sup.hero.subtitle': 'الشيء الوحيد الذي لا تقدمه معظم شركات سياحة الأسنان — والشيء الوحيد الذي يحدث كل الفرق.',
  'sup.why.title': 'معظم العيادات تعمل لصالحها. نحن نعمل لصالحك.',
  'sup.options.title': 'ثلاث طرق للبقاء محمياً',
  'sup.pillars.title': 'ما يحصل عليه كل مريض خاضع للإشراف',
  'sup.compare.title': 'مع الإشراف مقابل بدونه',
  'sup.faq.title': 'أسئلة حول الإشراف',
  'sup.cta.title': 'صحتك تستحق صوتاً مستقلاً.',
  'sup.cta.button': 'احجز مع الإشراف',

  // Common UI
  'common.learnMore': 'اعرف المزيد',
  'common.bookNow': 'احجز الآن',
  'common.startJourney': 'ابدأ رحلتي',
  'common.getStarted': 'ابدأ',
  'common.contactUs': 'تواصل معنا',
  'common.readMore': 'اقرأ المزيد',
  'common.viewAll': 'عرض الكل',
  'common.close': 'إغلاق',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.loading': 'جارٍ التحميل...',
  'common.error': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'common.required': 'هذا الحقل مطلوب',
  'common.optional': 'اختياري',
  'common.saving': 'توفير من',
  'common.perTooth': 'لكل سن',
  'common.included': 'مشمول',
  'common.mostTrusted': 'الأكثر موثوقية',
  'common.mostComfortable': 'الأكثر راحة',
  'common.yearsExperience': 'سنوات خبرة',
  'common.patients': 'مريض',
  'common.countries': 'دولة',
  'common.savings': 'توفير',
};

export default common;
